/**
 * social-proof-counter.js
 * Animates [.counter-animate] elements from 0 to their data-target value
 * when they enter the viewport. Fires once per element.
 * Eased with cubic ease-out for satisfying feel.
 */

(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseInt(el.dataset.target || '0', 10);
        if (isNaN(target)) return;
        animateCount(el, target);
        observer.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );

  document.querySelectorAll('.counter-animate').forEach((el) => {
    observer.observe(el);
  });

  function animateCount(el, target) {
    const duration = 1400; // ms
    const startTime = performance.now();
    const isDecimal = el.dataset.decimal === 'true';
    const suffix = el.dataset.suffix || '';

    function step(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // cubic ease-out
      const current = Math.round(eased * target);

      if (isDecimal) {
        el.textContent = (eased * (target / 10)).toFixed(1) + suffix;
      } else {
        el.textContent = current.toLocaleString('en-IN') + suffix;
      }

      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }
})();
